import variables from '@/assets/styles/element-variables.scss'
import DefaultConfig from '@/settings'
const { fixedHeader, sidebarLogo, uniqueOpened, showFooter, footerTxt, caseNumber } = DefaultConfig

const state = {
  theme: variables.theme,
  showSettings: false,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  uniqueOpened: uniqueOpened,
  showFooter: showFooter,
  footerTxt: footerTxt,
  caseNumber: caseNumber
}

export default {
  namespaced: true,
  state
}
